// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"Tag-module--container--2_9MM","tag":"Tag-module--tag--vUnMg","mytag":"Tag-module--mytag--76Wca"};